<template>
<div>
  <page-header :title="title"></page-header>
  <form @submit.prevent="gravar">
    <div class="modal-body">
      <div class="form-horizontal">
        <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
        <input-form-text textInput="Título" :required="true" v-model="form.titulo" :value="form.titulo"></input-form-text>
		<div class="form-group">
			<label class="col-sm-3 control-label no-padding-right">
				Selecione
			</label>
			<div class="col-sm-5">
				<div class="radio">
					<label>
						<input name="form-field-radio" type="radio" class="ace" data-enpassusermodified="yes" value="1" v-model="select">
						<span class="lbl"> Arquivo</span>
					</label>
				</div>
				<div class="radio">
					<label>
						<input name="form-field-radio" type="radio" class="ace" data-enpassusermodified="yes" value="2" v-model="select">
						<span class="lbl"> Link</span>
					</label>
				</div>
			</div>
		</div>
		<div v-if="select == 2">
			<input-form-text textInput="URL" v-model="form.arquivo"
				:value="form.arquivo"></input-form-text>
		</div>
		<div class="form-group" v-else>
			<label class="col-sm-3 control-label no-padding-right"></label>
			<div class="col-sm-5">
				<file-upload v-if="!allFiles.length" ref="fupload" :url="'/v1/vacinados/upload'" :id="null"
					:label="'PDF até 10 MB'" :multiple="false" texto="Enviar Arquivos" accept=".pdf"
					:isFile="true"></file-upload>
				<items-edit v-else :files="allFiles" url="/v1/vacinados/upload" id="id"
					:isFile="true"></items-edit>
			</div>
		</div>
        <div class="form-group">
          <select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id" titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
        </div>
      </div>
    </div>
    <footer-button :disabled="isActiveBtn"></footer-button>
  </form>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Vacinados',
			form: {
				titulo: '',
				arquivo: '',
				ativo: '1'
			},
			allFiles: [],
			isActiveBtn: false,
			isActive: false,
			select: 1
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				const resp = await req(`/v1/vacinados/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/links/vacinados')
			} else {
				const resp = await req('/v1/vacinados', 'post', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				if(this.$refs.fupload) {
					const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
					const m = tb[0]
					await m.uploadAll(resp)
				}
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/links/vacinados')
			}
			this.isActive = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/v1/vacinados/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.form.ativo = resp.ativo
			this.form.titulo = resp.titulo
			const test = /\/vacinados\//.exec(resp.arquivo)
			if(test && test.length) {
				this.select = 1
				this.allFiles = resp.arquivo ? [{ id: this.$route.params.arq, files: resp.arquivo }] : ''
			} else {
				this.select = 2
				this.form.arquivo = resp.arquivo
			}
			this.allFiles = resp.arquivo ? [{ id: this.$route.params.id, files: resp.arquivo }] : ''
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
